// extracted by mini-css-extract-plugin
export var parcelRow = "_uv-0";